import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { DayCustomersStatistics } from '@api/shipping-data/types/DayCustomersStatistics';
import { WebOrderStatistics } from '@api/shipping-data/types/WebOrderStatistics';
import { TileFilter } from '@api/shipping-data/types/TileFilter';
import { PagingInfo } from '@api/shipping-data/types/ListPage';



interface OrdersState {
	orders: WebOrderStatistics[] | null,
	ordersPagingInfo: PagingInfo | null,
	ordersFilter: TileFilter,
	selectedOrderUnvId: string | null,
	
	customers: DayCustomersStatistics[] | null,
	customersPagingInfo: PagingInfo | null,
	selectedCustomerUnvId: string | null,

	searchSingleOrderUnvId: string | null,
	gobackReportingsUrl: string | null,
};

const initialState: OrdersState = {
	orders: null,
	ordersPagingInfo: null,
	ordersFilter: TileFilter.totalOrders,
	selectedOrderUnvId: null,

	customers: null,
	customersPagingInfo: null,
	selectedCustomerUnvId: null,

	searchSingleOrderUnvId: null,
	gobackReportingsUrl: null,
};



export const ordersSlice = createSlice({
	name: 'orders',
	initialState,
	reducers: {
		setOrder: (state, action: PayloadAction<WebOrderStatistics>) => {
			state.orders = [ action.payload ];
			state.ordersPagingInfo = initialState.ordersPagingInfo;
			if (!state.selectedOrderUnvId && action.payload?.orderStatistics) {
				state.selectedOrderUnvId = action.payload.orderStatistics.unversionedSystemId;
			}
		},
		setOrdersAndPagingInfo: (state, action: PayloadAction<{ data: WebOrderStatistics[], pagingInfo: PagingInfo }>) => {
			state.orders = action.payload.data;
			state.ordersPagingInfo = action.payload.pagingInfo;
			if (!state.selectedOrderUnvId && action.payload?.data[0]?.orderStatistics) {
				state.selectedOrderUnvId = action.payload.data[0].orderStatistics.unversionedSystemId;
			}
		},
		setOrdersFilter: (state, action: PayloadAction<TileFilter>) => {
			state.ordersFilter = action.payload;
		},
		setSelectedOrderUnvId: (state, action: PayloadAction<string | null>) => {
			let previousId = state.selectedOrderUnvId;
			let nextId = action.payload;
			if (previousId === nextId) {
				state.selectedOrderUnvId = initialState.selectedOrderUnvId;
				return;
			}
			state.selectedOrderUnvId = nextId;
		},

		setCustomersAndPagingInfo: (state, action: PayloadAction<{ data: DayCustomersStatistics[], pagingInfo: PagingInfo }>) => {
			state.customers = action.payload.data;
			state.customersPagingInfo = action.payload.pagingInfo;
			if (!state.selectedCustomerUnvId && action.payload?.data[0]?.orderUnvDestinationId) {
				state.selectedCustomerUnvId = action.payload.data[0].orderUnvDestinationId;
			}
		},
		setSelectedCustomerUnvId: (state, action: PayloadAction<string | null>) => {
			let previousId = state.selectedCustomerUnvId;
			let nextId = action.payload;
			if (previousId === nextId) {
				state.selectedCustomerUnvId = initialState.selectedCustomerUnvId;
				return;
			}
			state.selectedCustomerUnvId = nextId;
		},

		setSearchSingleOrderUnvId: (state, action: PayloadAction<null | string>) => {
			state.searchSingleOrderUnvId = action.payload;
		},
		setGobackReportingsUrl:  (state, action: PayloadAction<null | string>) => {
			state.gobackReportingsUrl = action.payload;
		},
		resetOrdersAndCustomersStore: (state) => {
			state.orders = initialState.orders;
			state.ordersPagingInfo = initialState.ordersPagingInfo;
			state.ordersFilter = initialState.ordersFilter;
			state.selectedOrderUnvId = initialState.selectedOrderUnvId;

			state.customers = initialState.customers;
			state.customersPagingInfo = initialState.customersPagingInfo;
			state.selectedCustomerUnvId = initialState.selectedCustomerUnvId;
		},
		resetSearchStore: (state, action: PayloadAction<{ preserveSelectedOrderUnvId: boolean }>) => {
			state.orders = initialState.orders;
			state.ordersPagingInfo = initialState.ordersPagingInfo;
			state.ordersFilter = initialState.ordersFilter;

			if (!action.payload.preserveSelectedOrderUnvId) {
				state.selectedOrderUnvId = initialState.selectedOrderUnvId;
			}

			state.searchSingleOrderUnvId = initialState.searchSingleOrderUnvId;
			state.gobackReportingsUrl = initialState.gobackReportingsUrl;
		},
	},
});



export const {
	setOrder,
	setOrdersAndPagingInfo,
	setOrdersFilter,
	setSelectedOrderUnvId,

	setCustomersAndPagingInfo,
	setSelectedCustomerUnvId,
	
	setSearchSingleOrderUnvId,
	setGobackReportingsUrl,
	resetOrdersAndCustomersStore,
	resetSearchStore } = ordersSlice.actions;